import { InformationCircleIcon } from '@heroicons/react/24/outline';

interface CurrentPlanBannerProps {
  planName: string;
  trialDaysRemaining: number;
  trialEndsAt: Date | string;
}

export function CurrentPlanBanner({
  planName,
  trialDaysRemaining,
  trialEndsAt,
}: CurrentPlanBannerProps) {
  const formatDate = (date: Date | string): string => {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  };

  return (
    <div className="bg-info-surface-strong rounded-lg p-4 mb-6">
      <div className="flex items-start gap-3">
        <InformationCircleIcon className="h-5 w-5 text-info-foreground mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <p className="text-sm text-info-heading">
            You're currently on the <span className="font-semibold">{planName}</span> plan trial
            {' '}({trialDaysRemaining} {trialDaysRemaining === 1 ? 'day' : 'days'} remaining, ends{' '}
            {formatDate(trialEndsAt)})
          </p>
        </div>
      </div>
    </div>
  );
}
